import { Loading } from '@ui/components';
import { cn } from '@ui/utils';
import React from 'react';

interface DashboardCardContentProps extends React.ComponentPropsWithoutRef<'div'> {
  loaderSize?: 'medium' | 'small' | 'large';
  isLoading: boolean;
}

export const DashboardCardContent = (props: DashboardCardContentProps) => {
  const { children, isLoading, loaderSize = 'medium', className, ...rest } = props;

  return (
    <div
      className={cn(
        'flex flex-col w-full h-full overflow-auto',
        isLoading && '-mt-10 items-center justify-center',
        className,
      )}
      {...rest}
    >
      {isLoading && <Loading size={loaderSize} className="p-2" />}
      {!isLoading && <>{children}</>}
    </div>
  );
};
